<template>
	<div class="mabang-panel">
		<div class="title">
			<h3>订单详情</h3>
		</div>
		<div class="border"></div>
		<div class="content_pd" v-if="isServe">
			<h4>基本信息</h4>
			<el-row :gutter="20">
				<el-col :span="8" v-for="(item, idx) in baseInfoTitleAry" :key="idx">
					<div class="card_title">
						{{ item.title }}：{{
							item.prop == '' ? '-' : form.ecs[item.prop] == '' ? '-' : form.ecs[item.prop]
						}}
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="border" v-if="isServe"></div>
		<div class="content_pd" v-if="isServe">
			<h4>配置信息</h4>
			<el-row :gutter="20">
				<el-col :span="8" v-for="(item, idx) in configInfoTitleAry" :key="idx">
					<div class="card_title">
						{{ item.title }}：{{ form.ecs[item.prop] == '' ? '-' : form.ecs[item.prop] }}
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="border" v-if="isServe"></div>
		<div class="content_pd">
			<h4>付费信息</h4>
			<el-row :gutter="20">
				<el-col :span="8" v-for="(item, idx) in payInfoTitleAry" :key="idx">
					<div class="card_title">{{ item.title }}：{{ form[item.prop] == '' ? '-' : form[item.prop] }}</div>
				</el-col>
			</el-row>
		</div>
		<div class="border"></div>
		<div class="content_pd" style="padding-top: 20px">
			<el-button type="primary" size="small" @click="shut">关闭</el-button>
		</div>
	</div>
</template>

<script>
import { opderDetail } from '@/utils/api'

export default {
	data() {
		return {
			form: {},
			isServe: false,
			baseInfoTitleAry: [
				{
					title: '实例名称',
					prop: 'name',
				},
				{
					title: '实例ID',
					prop: 'gid',
				},
				{
					title: '备注',
					prop: 'description',
				},
				{
					title: '区域',
					prop: 'regionName',
				},
				{
					title: '可用区',
					prop: 'zoneName',
				},
				{
					title: '专有网络',
					prop: 'vpcName',
				},
				{
					title: '子网',
					prop: 'subnetName',
				},
				{
					title: '自定义镜像',
					prop: 'osVersion',
				},
				{
					title: '安全组',
					prop: 'securityGroupName',
				},
				{
					title: '分组',
					prop: '',
				},
				{
					title: '资源组',
					prop: 'resourceGroupName',
				},
				{
					title: '创建时间',
					prop: 'createAt',
				},
			],
			configInfoTitleAry: [
				{
					title: '规格',
					prop: 'sizeID',
				},
				{
					title: 'CPU',
					prop: 'cpu',
				},
				{
					title: '内存',
					prop: 'memory',
				},
				{
					title: '操作系统',
					prop: 'os',
				},
				{
					title: '私网IP',
					prop: 'privateIPAddress',
				},
				{
					title: '公网IP',
					prop: 'publicIPAddress',
				},
				{
					title: '密钥对',
					prop: 'keyPairName',
				},
			],
			payInfoTitleAry: [
				{
					title: '订单单号',
					prop: 'orderNo',
				},
				{
					title: '订单状态',
					prop: 'statusText',
				},
				{
					title: '购买商品',
					prop: 'productName',
				},
				{
					title: '付款时间',
					prop: 'payed_at',
				},
				{
					title: '付款金额',
					prop: 'amount',
				},
			],
		}
	},
	mounted() {
		this.reqopderDetail()
	},
	methods: {
		reqopderDetail() {
			let params = {
				orderNo: this.$route.query.orderNo,
			}
			opderDetail(params).then((res) => {
				if (!res) return
				if (res.ecs) {
					this.isServe = true
				} else {
					this.isServe = false
				}
				this.form = { ...res }
			})
		},
		//关闭
		shut() {
			this.$router.go(-1)
		},
	},
}
</script>

<style scoped>
.card_title {
	height: 40px;
	line-height: 40px;
	color: #72777b;
	font-size: 14px;
}
.content_pd {
	padding: 0 30px;
}
</style>
